import { Point } from './types.js';

/**
    @function segmentBoxContains
    @desc Checks whether a point is inside the bounding box of a line segment.
    @param {Array} s1 The first point of the line segment to be used for the bounding box, which should always be an `[x, y]` formatted Array.
    @param {Array} s2 The second point of the line segment to be used for the bounding box, which should always be an `[x, y]` formatted Array.
    @param {Array} p The point to be checked, which should always be an `[x, y]` formatted Array.
    @returns {Boolean}
*/
export const segmentBoxContains = (s1: Point, s2: Point, p: Point): boolean => {
  const eps: number = 1e-9;
  const [px, py]: Point = p;

  return !(
    px < Math.min(s1[0], s2[0]) - eps ||
    px > Math.max(s1[0], s2[0]) + eps ||
    py < Math.min(s1[1], s2[1]) - eps ||
    py > Math.max(s1[1], s2[1]) + eps
  );
};
